
import foFooter from '@/components/footer/footer.vue'
import foHeader from '@/components/header/header.vue'
import { ROUTES } from '@/constants'
import { collectMixin } from '@/mixins'
import { SET_IS_LOADING_APP } from '@/store/mutation-types'
import { SnackBarType } from '@/store/types'
import mustache from 'mustache'
import mixins from 'vue-typed-mixins'

export default mixins(collectMixin).extend({
  name: 'survey-confirmation',
  components: { foHeader, foFooter },
  data: () => ({
    hasLoaded: false,
  }),
  computed: {
    parsedContent(): string | undefined {
      if (this.clientPage?.config.customContent?.body) {
        return mustache.render(
          this.clientPage!.config.customContent?.body
            .replace(/<p>(.*?)<\/p>/gm, '$1')
            .replace(/&lt;/gm, '<')
            .replace(/&gt;/gm, '>')
            .replace(/&amp;/gm, '&')
            .replace(/&nbsp;/gm, ' ')
            .replace(/<br>/gm, ''),
          {},
        )
      }
    },
  },
  async mounted() {
    try {
      await this.getCollect(this.$route.name!)

      if (!this.clientPage || !this.collect || this.collect.status !== 'COLLECT_PICK_UP_OK') {
        return this.$router.push({ name: ROUTES.NOT_FOUND })
      }
    } catch (e) {
      this.$store.dispatch('setSnackbar', {
        message: this.$t('messages.error'),
        type: SnackBarType.ERROR,
      })
    }

    this.hasLoaded = true
    this.$store.commit(SET_IS_LOADING_APP, false)
  },
})
